"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.wip.title': 'Work In Progress',
    'socialMediaPlan.wip.description': 'Social media planning features are coming soon.',
};
